/** Shared across application builds; separate from Angular mode and log enablement. */
export const SENTRY_SAMPLING = Object.freeze({
  // Preserve the current effective trace rate during local verification.
  tracesSampleRate: 1.0,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});
